import { render, staticRenderFns } from "./CopyToClipboardButton.vue?vue&type=template&id=bc9f0880&"
import script from "./CopyToClipboardButton.vue?vue&type=script&lang=js&"
export * from "./CopyToClipboardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports